import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const TermsOfService = () => (
  <div className="min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-pink-50 to-indigo-50 py-12 px-2">
    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full p-8 md:p-12">
      <div className="flex items-center justify-center mb-4">
        <DocumentTextIcon className="h-10 w-10 text-pink-500 mr-2" />
        <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-500 drop-shadow">
          Terms of Service
        </h1>
      </div>
      <p className="mb-6 text-lg text-gray-700 text-center">
        Welcome to theVastra.store! By using our website, you agree to the following terms and conditions:
      </p>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">User Responsibilities</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">You must provide accurate and complete information when creating an account or placing an order.</li>
          <li className="marker:text-pink-500">You are responsible for maintaining the confidentiality of your account credentials.</li>
          <li className="marker:text-pink-500">You agree not to misuse our services or attempt to harm our website or users.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Order Process</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">All orders are subject to availability and confirmation.</li>
          <li className="marker:text-pink-500">You will receive an order confirmation email after placing your order.</li>
          <li className="marker:text-pink-500">We reserve the right to cancel or refuse any order at our discretion.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Payment Terms</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">Payments must be made in full at the time of purchase.</li>
          <li className="marker:text-pink-500">We accept UPI, credit/debit cards, and other payment methods as listed at checkout.</li>
          <li className="marker:text-pink-500">All transactions are processed securely.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Shipping & Delivery</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">Shipping times may vary based on your location and product availability.</li>
          <li className="marker:text-pink-500">We are not responsible for delays caused by external factors (e.g., courier delays, weather).</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Returns & Refunds</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">Please refer to our <a href='/cancellation' className='text-indigo-600 underline'>Cancellation & Refund Policy</a> for details.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Limitation of Liability</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">We are not liable for any indirect, incidental, or consequential damages arising from your use of our website or services.</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Governing Law</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">These terms are governed by the laws of India.</li>
        </ul>
      </section>
      <div className="text-right text-sm text-gray-500">Last updated: July 2024</div>
    </div>
  </div>
);

export default TermsOfService; 